import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

export const ExportCSV = (props) => {
  const { csvData, csvHeaders, csvFileName } = props;

  if (csvData === undefined) {
    return null;
  }
  return (
    <CSVLink
      data={csvData}
      headers={csvHeaders}
      filename={csvFileName + "-csv-export.csv"}
      separator={";"}
    >
      <Tooltip title={"Export"}>
        <Button icon={<DownloadOutlined />} size="middle" />
      </Tooltip>
    </CSVLink>
  );
};
